var showModalId = ''
if ($('#product-categories').length) {

    if (orderViewModel.scLanguageCode !== undefined && ((orderViewModel.scLanguageCode).toLowerCase() !== ($("html").attr("lang").split("-").pop()).toLowerCase()) && !orderViewModel.isLangChanged) {
        $('.change-language-banner').show();
        orderViewModel.isCountryChanged = true;
        orderViewModel.save();

        changeCountry();
    }

    function changeCountry() {
        if ($('.container .lang-select-desktop .menu-item:visible').length == 2) {
            m = $('.country-language li.menu-item.menu-item-has-children.a11y-mouse-listen-init').find('.sub-menu');
            p = $('.country-language li.menu-item.menu-item-has-children.a11y-mouse-listen-init');
            Dropdown.showMenu(m, p);
        }

        if ($(window).width() < 1024) {
            if ($('html[lang *= "CA"]').length == 1) {
                $('#changeLangText').show();
            } else {
                $('#changeLangText').hide();
            }
        }
    }

    $('.sub-menu .menu-item').on('click', function () {
        orderViewModel.isLangChanged = true;
        orderViewModel.isCountryChanged = false;
        orderViewModel.save();
    });

    if (orderViewModel.isLangChanged) {
        $('.change-language-banner').hide();
    }
    (function () {

        $(function () {
            var action = $('#frmRestaurantMenu').attr('action');
            ajaxGetResults(action, 'frmRestaurantMenu');
        });

        // STICKY SUBNAV
        $(function () {
            if (ShopPromotionFlag == "true" && orderViewModel.showRedirectSuccessBanner) {
                orderViewModel.showRedirectSuccessBanner = false;
                orderViewModel.save();
                getBannerMessage('success', orderViewModel.redirectBannerMessage);
                analytics.removalBannerAnalytics(orderViewModel.redirectBannerMessage);
            }
            if (orderViewModel &&
                orderViewModel.selectedOffer &&
                orderViewModel.selectedOffer.confirmedValid === true) {
                orderViewModel.selectedOffer = null;
                orderViewModel.save();
                function categoryResize() {
                    var favAmt = document.getElementsByClassName('favorites').length;
                    void 0;
                    if (favAmt == 1) {
                        $('.favorites').addClass('single-category-desktop');
                    }
                }

                categoryResize();

                //added in the sticky2 class so that the deals applied subnav is sticky under the locater nav in mobile
                function stickNav() {
                    $('.navbar-main').addClass('sticky');
                    $(".navbar-sub.sticky").trigger("sticky_kit:detach");
                    $(".navbar-sub.sticky2").trigger("sticky_kit:detach");

                }

                $(function () {
                    //only apply sticky classes when at a mobile breakpoint
                    if ($(window).width() < 1024) {
                        stickNav();

                    } else {
                        $('.navbar-main').removeClass('sticky');
                        $('.navbar-deal-applied').removeClass('sticky2');
                    }

                    var resizeTimer;

                    $(window).resize(function (e) {

                        clearTimeout(resizeTimer);
                        resizeTimer = setTimeout(function () {

                            // applies generically to all items with sticky class
                            categoryResize();

                            if ($(window).width() < 1024) {
                                stickNav();

                            } else {
                                $(".sticky").trigger("sticky_kit:detach");
                                $(".sticky2").trigger("sticky_kit:detach");
                                $('.navbar').last().removeClass('nav-shadow');
                            }


                        },
                            50);
                    });
                });
            }

        });


        function ajaxGetResults(postUrl, formId) {
            subwayScript.showSpinner();
            subwayScript.showSpinner1();
            $.ajax({
                url: postUrl,
                type: 'POST',
                data: $('#' + formId).serialize(),
                success: function (data) {
                    $('#menu-loader').hide();

                    if (data.Error !== undefined) {
                        if (data.Error.Url !== null && data.Error.Url !== undefined) {
                            window.location.href = data.Error.Url;
                        }
                    }
                    $('#product-categories-list').html(data);
                    categoryResize();
                    if (orderViewModel.currentOrder && !orderViewModel.currentOrder.cartId) {
                        createNewCart();
                    }
                    if ($(window).width() < 1024) {
                        $(".product-grid li").addClass("wide");
                    }
                    subwayScript.hideSpinner();
                    subwayScript.hideSpinner1();
                    if (orderViewModel.showRedirectSuccessBanner) {
                        orderViewModel.showRedirectSuccessBanner = false;
                        orderViewModel.save();
                        getBannerMessage('success', orderViewModel.redirectBannerMessage);
                        analytics.removalBannerAnalytics(orderViewModel.redirectBannerMessage);
                    }
                },
                error: function (jqXhr) {
                    subwayScript.showAjaxError(jqXhr);
                    subwayScript.hideSpinner();
                    subwayScript.hideSpinner1();
                }
            });
        }


        $(window).resize(function (e) {
            categoryResize();
            changeCountry();
            if ($(window).width() < 1024) {
                $(".product-grid li").addClass("wide");
            } else {
                if ($('.product-grid li:nth-child(1)').hasClass('favorites')) {
                    $('.product-grid li').removeClass('wide')
                    $('.product-grid li:nth-child(2)').addClass('wide')
                } else {
                    $('.product-grid li').removeClass('wide')
                    $('.product-grid li:nth-child(1)').addClass('wide')
                }
            }
        });

        function categoryResize() {
            var favAmt = document.getElementsByClassName('favorites').length;
            if (favAmt == 1) {
                $('.favorites').addClass('single-category-desktop');
            }
        }

        $(function () {
            var $categories = $('.product-grid');
            var $category = $('li', $categories);
            var $categorylink = $('a', $category);

            // set active selected on focus
            $('li')
                .focusin(function () {
                    $(this).addClass('active');
                });
            $('li')
                .focusout(function () {
                    $(this).removeClass('active');
                });

            // map keys
            var keyCode = {
                13: 'enter',
                27: 'escape',
                38: 'up',
                40: 'bottom',
                37: 'left',
                39: 'right'
            }

            // listen for keyup
            window.addEventListener('keyup',
                function (e) {
                    if (e.origin !== window.location.origin) {
                        return;
                    }
                    // get key pressed
                    var key = keyCode[e.which];
                    // get  active categories
                    var $active = $('.active');

                    if (key === 'enter') {
                        // deselect if already selected
                        if ($active.hasClass('selected')) {
                            $active.removeClass('selected');
                        } else {
                            $active.addClass('selected');
                        }
                    }

                    if (key === 'right') {
                        $category.removeClass('active').attr('aria-selected', 'false');

                        if ($active.length === 0) {
                            $categorylink.first().focus().attr('aria-selected', 'true');
                        } else if ($active.next().length === 0) {
                            $active.siblings().first().addClass('active').attr('aria-selected', 'true');
                            $('.active a').focus();
                        } else {
                            $active.next().addClass('active').attr('aria-selected', 'true');
                            $('.active a').focus();
                        }
                    }

                    if (key === 'left') {
                        $category.removeClass('active').attr('aria-selected', 'false');

                        if ($active.prev().length === 0) {
                            $active.siblings().last().addClass('active').attr('aria-selected', 'true');
                            $('.active a').focus();
                        } else {
                            $active.prev().addClass('active').attr('aria-selected', 'true');
                            $('.active a').focus();
                        }
                    }
                },
                false);
        });
    })();
}

$(function () {
    if ($('#menu-slider').length) {
        var formId = $('#frmMenuSlider');
        var resultBindingId = $('#menu-slider');
        GetNationalMenu(formId, resultBindingId, true);
    }

    if ($('#national-menu-landing').length) {
        var formId = $('#frmNationalMenu');
        var resultBindingId = $('#national-menu-landing');
        GetNationalMenu(formId, resultBindingId, false);
    }

    if ($('#menu-slider-sitecore').length) {
        var formId = $('#frmMenuSliderSitecore');
        var resultBindingId = $('#menu-slider-sitecore');
        GetNationalMenu(formId, resultBindingId, true);
    }
});

function GetNationalMenu(formId, resultBindingId, isMenuSliderShow) {
    var postUrl = formId.attr('action');
    var objDomain = $('#footerheaderdomain').val();
    if (objDomain !== undefined) {
        postUrl = "https://" + objDomain + postUrl;
    }
    var storeId = "";
    if (orderViewModel != null && orderViewModel.store != null) {
        storeId = orderViewModel.store.id;
    }
    $('[name="RestaurantId"]', formId).val(storeId); 
    $.ajax({
        url: postUrl,
        type: 'POST',
        data: formId.serialize(),
        success: function (data) {
            $(".nationalMenu_skeletonLoader").remove()
            $(".menu-landing_skeletonLoader").remove()
            document.dispatchEvent(new CustomEvent('apiCallSuccess'));
            if (data.Error !== undefined) {
                if (data.Error.Url !== null && data.Error.Url !== undefined) {
                    window.location.href = data.Error.Url;
                }
            }

            resultBindingId.html(data);
            subwayScript.hideSpinner();
            if (isMenuSliderShow) {
                globalUtil.attachMenuSlider('.menu_slider', '.menu_next_button', '.menu_prev_button');
            }
        },
        error: function (jqXhr) {
            subwayScript.showAjaxError(jqXhr);
        }
    });
}

function createNewCart() {
    const $restaurantID = $("input[name=RestaurantId]");
    const newStoreID = $restaurantID.val();
    createCartInCategories(newStoreID);
}

function createCartInCategories(storeID, fromDefaultStore = false, orderType) {
    var $frmCreateCart = $('#frmCreateCart');
    var newStoreID = storeID;
    var cartid = orderViewModel.currentOrder.cartId;
    var createCartDetails = {
        storeId: newStoreID
    };

    if (orderViewModel.store.StoreId !== subwayScript.getStoreId(orderViewModel.store.storeNumber, orderViewModel.store.SatelliteNumber)) {

        createCartDetails.StreetAddressLine1 = orderViewModel.DeliveryAddress.StreetAddressLine1,
            createCartDetails.StreetAddressLine2 = orderViewModel.DeliveryAddress.StreetAddressLine2,
            createCartDetails.City = orderViewModel.DeliveryAddress.City,
            createCartDetails.State = orderViewModel.DeliveryAddress.State,
            createCartDetails.Zip = orderViewModel.DeliveryAddress.Zip,
            createCartDetails.Country = orderViewModel.DeliveryAddress.Country,
            createCartDetails.DirectDelivery = orderViewModel.DeliveryAddress.DirectDelivery,
            createCartDetails.QuoteId = orderViewModel.DeliveryAddress.QuoteId,
            createCartDetails.OrderType = orderViewModel.orderType || orderType,
            createCartDetails.SiteName = $('#hdnSiteName').val() || null
    }

    analytics.createCart(cartid);
    if (!orderViewModel.currentOrder.cartId || !orderViewModel.store.id || newStoreID != orderViewModel.store.id) {
        subwayScript.showSpinner();
        $.ajax({
            url: $frmCreateCart.attr('action'),
            type: 'POST',
            cache: false,
            async: true,
            headers: { "cache-control": "no-cache" },
            data: createCartDetails,
            error: function (jqXhr) {
                if (jqXhr.responseJSON && (jqXhr.responseJSON.Error.ErrorCode.toLowerCase() == 'dord-3006' || jqXhr.responseJSON.Error.ErrorCode.toLowerCase() == 'ordr-3000')) {
                    modalShowId('#modal-store-closed');
                }
                else {
                    subwayScript.hideSpinner();
                    subwayScript.showAjaxError(jqXhr);
                }

            },
            success: function (resultData) {
                if (resultData.Error) {
                    subwayScript.showAjaxError(resultData);
                } else if (!resultData.IsWebOrderAvailable) {

                    if (!fromDefaultStore) {
                        modalShowId('#modal-web-order-not-available');
                        const errMsg = $('#modal-web-order-not-available .error-body').text() || ''
                        analytics.errorMessage(errMsg, 'n/a', 'n/a', false)
                    } else {
                        showModalId = '#modal-web-order-not-available';
                        orderViewModel.showModalId = showModalId;
                        orderViewModel.save()

                    }
                } else if (!resultData.IsStoreOpen) {
                    var title = $('#modal-store-closed').find('.error-title').text() || $('#modal-store-closed').find('.head-txt').text();
                    var body = $('#modal-store-closed').find('.error-body').text() || $('#modal-store-closed').find('.body-txt').text();
                    if (!fromDefaultStore) {
                        analytics.pageError(title, body, 'n/a', 'n/a', false);
                        modalShowId('#modal-store-closed');
                    } else {
                        showModalId = '#modal-store-closed'
                        orderViewModel.showModalId = showModalId;
                        orderViewModel.save()
                    }


                } else {
                    showModalId = ''
                    orderViewModel.showModalId = ''
                    var curContext = subwayScript.navigation.getLanguageCode();
                    if (curContext.indexOf(resultData.AvailableStoreCultures) === -1) {
                        redirectToLanguageContext(resultData.AvailableStoreCultures);
                    }
                    if (fromDefaultStore) {
                        if (resultData.HasCurbsideAfterHours && resultData.HasCurbsideBeforeHours === false && orderType === 'curbside') {
                            showModalId = '#curbside-not-available';
                            $("#curbside-not-available .street-Address-1").text(resultData.Store.Address.StreetAddress1);
                            $("#curbside-not-available .city-State-Country").text(resultData.Store.Address.CityStateCountry);
                            $('#curbside-not-available #schedule-later-pickup').hide();
                            $('#curbside-not-available .curbsidetext').text(resultData.CurbsideNotAvailableMsg);
                        }
                    }

                    resultData.Store.StoreId = newStoreID; //Satellite Number is not getting form API, so set new store id
                    subwayScript.updateStoreDetails(resultData.Store);
                    orderViewModel.currentOrder.cartId = resultData.Cart.CartId;
                    orderViewModel.currentOrder.cartQuantity = 0;
                    orderViewModel.cartOpen = true;
                    if (fromDefaultStore) {
                        orderViewModel.orderType = orderType;
                        orderViewModel.AnalyticsorderType = getOrderTypeByFulfillmentType(orderType);
                        hideLanguageFromDropdown();
                    }
                    orderViewModel.promoCode = {}
                    orderViewModel.storeStatus = resultData.IsStoreOpen;
                    orderViewModel.save();
                    subwayScript.setCookie('CartId', orderViewModel.currentOrder.cartId, 90);
                    eraseCookie("CurbSideToggle");
                    analytics.defaultOrderType()
                    eraseCookie("pickup_time_ready_at");
                    analytics.setGlobalValues();
                    if (!fromDefaultStore)
                        SelectHeader();
                }
                subwayScript.hideSpinner();
            }
        });
    }
}